import { register } from '@planningcenter/tapestry/reactRender'
import { application } from '~/controllers/application'
import ReactMountController from '~/controllers/react_mount_controller'

const componentModules = import.meta.glob('~/components/**/*.{jsx,tsx}', {
  eager: true,
})

export function setupReactMountController() {
  registerAll(componentModules)
  application.register('react-mount', ReactMountController)
}

function registerAll(modules) {
  Object.entries(modules).forEach(([path, module]) => {
    const name = pathToName(path)
    const Component = module.default || module
    register(name, Component)
  })
}

function pathToName(path) {
  return path.replace(/^.*\/components\//, '').replace(/\.(jsx?|tsx?)$/, '')
}
